import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Events from "./pages/Events";
import Header from "./components/Header";
import AddEvents from "./components/AddEvents";
import About from "./pages/about";

function App() {
  const [events, setEvents] = useState([
    { id: 1, title: "Charity Run", date: "15-03-2028", category: "Charity", location: "Hyderabad" },
    { id: 2, title: "Faith Gathering", date: "18-03-2025", category: "Religious", location: "Delhi" },
    { id: 3, title: "Community Picnic", date: "28-03-2025", category: "Social", location: "Pune" }
  ]);

  const addEvent = (event) => {
    setEvents((prevEvents) => {
      console.log("Previous Events:", prevEvents);
      console.log("Adding Event:", event);
      return [...prevEvents, event];
    });
  };


  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events events={events} addEvent={addEvent} />} />
        <Route path="/add_events" element={<AddEvents addEvent={addEvent} />} />
        <Route path="/about" element={<About />} />
      </Routes>

    </Router>
  );
}

export default App;
